import { render } from "./IconSuccess.vue?vue&type=template&id=97efd97a&ts=true"
import script from "./IconSuccess.vue?vue&type=script&lang=ts"
export * from "./IconSuccess.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__